// ── QuickEntryFAB — 우측 하단 floating action button ──
// 클릭 → 매출/비용 입력 메뉴 펼침
import React, { useState } from 'react';

export default function QuickEntryFAB({ onOpenRevenue, onOpenExpense, isMobile }) {
  const [open, setOpen] = useState(false);

  const toggle = () => setOpen(o => !o);
  const handleRevenue = () => { setOpen(false); onOpenRevenue && onOpenRevenue(); };
  const handleExpense = () => { setOpen(false); onOpenExpense && onOpenExpense(); };

  return (
    <>
      {/* Backdrop (메뉴 열렸을 때 외부 클릭 닫기) */}
      {open && (
        <div onClick={() => setOpen(false)} style={{
          position: 'fixed', inset: 0,
          background: 'rgba(0,0,0,0.15)',
          zIndex: 998,
        }} />
      )}

      {/* FAB 컨테이너 */}
      <div style={{
        position: 'fixed',
        bottom: isMobile ? 18 : 28,
        right: isMobile ? 18 : 28,
        zIndex: 999,
        display: 'flex', flexDirection: 'column-reverse', alignItems: 'flex-end', gap: 12,
      }}>
        {/* 메인 + 버튼 */}
        <button onClick={toggle} aria-label="빠른 입력" style={{
          width: isMobile ? 56 : 60,
          height: isMobile ? 56 : 60,
          borderRadius: '50%',
          border: 'none',
          background: open
            ? '#71717A'
            : '#EA580C',
          color: '#fff',
          fontSize: 24,
          fontWeight: 900,
          cursor: 'pointer',
          boxShadow: '0 6px 20px rgba(30,107,60,0.35)',
          transition: 'all 0.2s',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          transform: open ? 'rotate(45deg)' : 'rotate(0)',
        }}>
          +
        </button>

        {/* 펼쳐지는 메뉴 (open일 때만) */}
        {open && (
          <>
            {/* 매출 입력 */}
            <button onClick={handleRevenue} style={{
              padding: '10px 18px',
              borderRadius: 28,
              border: 'none',
              background: '#fff',
              boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
              cursor: 'pointer',
              display: 'flex', alignItems: 'center', gap: 10,
              animation: 'fab-pop-in 0.2s ease',
            }}>
              <span style={{
                width: 32, height: 32, borderRadius: '50%',
                background: '#EA580C',
                color: '#fff', fontSize: 16,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0,
              }}>✏️</span>
              <span style={{
                fontSize: 13, fontWeight: 800, color: '#18181B',
                whiteSpace: 'nowrap',
              }}>매출 입력</span>
            </button>

            {/* 비용 입력 */}
            <button onClick={handleExpense} style={{
              padding: '10px 18px',
              borderRadius: 28,
              border: 'none',
              background: '#fff',
              boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
              cursor: 'pointer',
              display: 'flex', alignItems: 'center', gap: 10,
              animation: 'fab-pop-in 0.2s ease 0.05s both',
            }}>
              <span style={{
                width: 32, height: 32, borderRadius: '50%',
                background: '#EA580C',
                color: '#fff', fontSize: 16,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0,
              }}>💸</span>
              <span style={{
                fontSize: 13, fontWeight: 800, color: '#EA580C',
                whiteSpace: 'nowrap',
              }}>비용 입력</span>
            </button>
          </>
        )}
      </div>

      {/* 애니메이션 keyframes (인라인 style 태그) */}
      <style>{`
        @keyframes fab-pop-in {
          0% { opacity: 0; transform: translateY(8px) scale(0.9); }
          100% { opacity: 1; transform: translateY(0) scale(1); }
        }
      `}</style>
    </>
  );
}
